<template>
  <top-page-table-header color="red" url="/notifications">
    <template v-slot:icon>
      <notification-icn
        class="red-icon ml-2 mr-2"
        width="20px"
        height="20px"
      ></notification-icn>
      <span class="text-red text-lg font-bold"
        >お知らせ（{{ notificationTop.length }}）</span
      >
    </template>

    <template v-slot:btn-content>
      <notification-icn
        class="red-icon ml-4 mr-1"
        width="20px"
        height="20px"
      ></notification-icn>
      <div class="flex flex-row items-baseline">
        <span class="text-red text-lg font-bold">お知らせ</span>
        <span class="text-red text-sm font-bold">ページへ</span>
      </div>
    </template>
  </top-page-table-header>

  <app-table v-bind="$attrs" class="w-full">
    <template v-slot:table-body>
      <tr
        v-for="(item, index) in notificationTop"
        :key="'aaa' + index"
        class="bg-white border border-collapse border-dashed border-red border-t-0 border-l-0 border-r-0 h-12 hover:bg-red-lightestNonOpacity"
        @click="openActiveDialog(item)"
      >
        <td width="36px">
          <img
            class="mx-2 my-3"
            :src="getTypeIcon(item.documentType)"
            style="width:20px;height:20px;"
          />
        </td>
        <td width="108px">
          <span class="text-lg mr-3">{{
            $filters.dateFormat(item.updatedAt)
          }}</span>
        </td>
        <td>
          <div class="flex flex-row items-center">
            <user-circle-icn
              width="20"
              height="20"
              class="red-icon-user"
              style="flex-shrink: 0;"
            ></user-circle-icn>
            <div>
              <span
                class="ml-1 text-lg"
                :class="item.user.id === currentUser.id ? 'font-bold' : ''"
              >
                {{ item.user.uname }}
              </span>
              <span class="ml-1 text-lg">{{ item.firstText }}</span>
            </div>
          </div>
        </td>
        <td width="49%">
          <div class="flex flex-row items-center">
            <img
              class="mr-1"
              :src="getIcon(item.updateType)"
              style="width:20px;height:20px;"
            />
            <span class="text-lg omit_yokohama">{{ item.secondText }}</span>
          </div>
        </td>
      </tr>
    </template>
  </app-table>
</template>

<script>
import { ref, onMounted } from 'vue'

import AppTable from '@/components/ui/AppTable'
import TopPageTableHeader from '@/components/layout/top/TopPageTableHeader'
import NotificationIcn from '@/assets/icons/notification.svg?inline'
import UserCircleIcn from '@/assets/icons/user-circle.svg?inline'
import { useCurrentUser } from '@/services/useCurrentUser'
import { useTopData } from '@/services/useHome'
import { useStatus } from '@/services/notification/useStatus'
import { useBudgetDialog } from '@/services/useBudgetDialog'
import { useReceiptDialog } from '@/services/receiptsToda/useReceiptDialog'
import { usePoliticalActionDialog } from '@/services/politicalActionToda/usePoliticalActionDialog'
import { useDialog } from '@/services/useDialog'

export default {
  name: 'TopPageNotificationsTable_TODA',

  components: {
    AppTable,
    NotificationIcn,
    TopPageTableHeader,
    UserCircleIcn,
  },

  setup() {
    const count = ref(5)
    const { currentUser } = useCurrentUser()
    const { getNotificationTop, notificationTop } = useTopData()
    const { convertStatus, getTypeIcon, getIcon } = useStatus()
    const { openBudgetPreviewRegistered } = useBudgetDialog()
    const { openReceiptDialog } = useReceiptDialog()
    const { changeDocument } = usePoliticalActionDialog()
    const { isOpen, type } = useDialog()

    const openActiveDialog = item => {
      if (item.documentType === 1) {
        openBudgetPreviewRegistered(item.documentId)
        return
      }
      if (item.documentType === 2) {
        openReceiptDialog(item.documentId)
        return
      }
      if (
        item.documentType === 3 ||
        item.documentType === 4 ||
        item.documentType === 5
      ) {
        changeDocument(item.documentType, item.documentId)
        return
      }
    }

    onMounted(async () => {
      await getNotificationTop()
    })
    return {
      count,
      notificationTop,
      currentUser,
      convertStatus,
      getTypeIcon,
      getIcon,
      isOpen,
      type,
      openActiveDialog,
    }
  },
}
</script>
<style lang="scss">
.omit_yokohama {
  max-width: calc(100vw / 2 - 32px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
